import { handleActions } from 'redux-actions';

const initialState = {
  open: false,
  openDetail: false,
};

const bottomBar = handleActions(
  {
    OPEN_BOTTOM_BAR: state => ({
      ...state,
      open: true,
      openDetail: false,
    }),
    TOGGLE_BOTTOM_BAR_DETAIL: state => ({
      ...state,
      openDetail: !state.openDetail,
    }),
    HIDE_BOTTOM_BAR: () => initialState,
  },
  initialState,
);

export default bottomBar;



// WEBPACK FOOTER //
// ./src/store/reducers/BottomBar/index.js